<template>
  <div class="contentoutside">
    <div class="content">
      <div class="header">
        <div class="cancel">取消</div>
        <div class="title">选择附件类型</div>
        <div class="ok">确定</div>
      </div>
      <div class="content-footer">
        <div class="content_t">
          <div class="center-line"></div>
          <div class="content-inside" ref="outdiv">
            <div class="text" v-for="item in scrolldata" :key="item.id">{{ item.text }}</div>
          </div>
          <div class="bottomopacity" :sytle="getCoverStyle"></div>
          <div class="divider" :style="getDividerStyle"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const a = -0.003; // 加速度
const radius = 100; // 半径
const lineHeight = 36; // 文字行高
let isInertial = false; // 是否正在惯性滑动
// 根据三角形余弦公式
// 反余弦得到弧度再转换为度数,这个度数是单行文字所占有的。
let deg = Math.round(
  (Math.acos(
    (radius * radius + radius * radius - lineHeight * lineHeight) /
      (2 * radius * radius)
  ) *
    180) /
    Math.PI
);
// deg这个值须360能整除，因为当滚动列占满一周后可以再次均匀的覆盖在上一周文字上；滚动时不会出现错位
while (360 % deg !== 0 && deg <= 360) {
  deg += 1;
}
const singleDeg = deg;
// 半圆下的内容条数
const space = Math.floor(360 / singleDeg / 2);
let juli = 15;
import Animate from "./animate";
export default {
  name: "scrollPicker",
  props: {
    isShow: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  data() {
    return {
      scrolldata: [
        { id: "1", text: "人员到位情况" },
        { id: "2", text: "分发、转办事项落实情况" },
        { id: "3", text: "重大涉旅信息报送情况" },
        { id: "4", text: "工作制度情况" },
        { id: "5", text: "5" },
        { id: "6", text: "6" },
        { id: "7", text: "7" },
        { id: "8", text: "8" },
        { id: "9", text: "9" },
        { id: "10", text: "10" },
        { id: "11", text: "11" },
        { id: "12", text: "12" },
        { id: "13", text: "13" },
        { id: "14", text: "14" },
        { id: "15", text: "15" },
        { id: "16", text: "16" },
        { id: "17", text: "17" },
        { id: "18", text: "18" },
        { id: "19", text: "19" },
        { id: "20", text: "20" },
        { id: "21", text: "21" },
        { id: "22", text: "22" },
        { id: "23", text: "23" },
        { id: "24", text: "24" },
        { id: "25", text: "25" },
        { id: "26", text: "26" }
      ],
      finger: {
        startY: 0,
        endY: 0,
        startTime: 0, // 开始滑动时间（单位：毫秒）
        entTime: 0, // 结束滑动时间（单位：毫秒）
        currentMove: 0,
        prevMove: 0
      },
      range: {
        start: -space,
        end: space,
        space
      }
    };
  },
  computed: {
    getCoverStyle() {
        return {
          backgroundSize: `100% ${radius - Math.round(lineHeight / 2)}px`,
        };
      },
      getDividerStyle() {
        return {
          top: `${radius - Math.round(lineHeight / 2)}px`,
          height: `${lineHeight - 2}px`,
        };
      },
    animate() {
      return new Animate();
    }
  },
  mounted() {
    this.listenerTouchStart();
    this.listenerTouchMove();
    this.listenerTouchEnd();
  },
  methods: {
    listenerTouchStart() {
      let scroll = this.$refs.outdiv;
      const _this = this;
      scroll.addEventListener("touchstart", function(ev) {
        isInertial = false;
        _this.finger.startY = ev.targetTouches[0].pageY;
        _this.finger.prevMove = _this.finger.currentMove;
        _this.finger.startTime = Date.now();
      });
    },
    listenerTouchMove() {
      let scroll = this.$refs.outdiv;
      const _this = this;
      let index = 1;
      scroll.addEventListener("touchmove", function(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        const move =
          _this.finger.startY -
          ev.targetTouches[0].pageY +
          _this.finger.prevMove;
        _this.finger.currentMove = move;
        if (move >= _this.scrolldata.length * 40) {
          return;
        }
        if (move < 0) {
          return;
        }
        scroll.style.transform = ` translate3d(0px, ${-move}px, 0px)`;
        scroll.style.transitionDuration = "0ms";
        scroll.style.transitionProperty = "none";
      });
    },
    listenerTouchEnd() {
      let scroll = this.$refs.outdiv;
      const _this = this;
      scroll.addEventListener("touchend", function(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        _this.finger.endY = ev.changedTouches[0].pageY;
        _this.finger.endTime = Date.now();
        _this.getInertiaDistance();
      });
    },

    getRangeData(index) {
      const zhi = this.scrolldata[
        index >= 0 ? Math.floor(index) : index + this.scrolldata.length
      ];
      if (zhi) {
        return zhi.text;
      }
    },
    getSelectValue(move) {
      const index = Math.abs(move / lineHeight);
      const pickValue = this.getRangeData(index);
      console.log("-----选中的值:", pickValue);
      // this.$emit("select", pickValue);
    },
    /**
     * 求移动速度（v = s / t），判断用户操作快慢，从而得到惯性的滑动距离
     */
    getInertiaDistance() {
      // 移动距离
      const s = this.finger.startY - this.finger.endY;
      // 移动时间
      const t = this.finger.endTime - this.finger.startTime;
      // 移动速度
      const v = s / t;
      const absV = Math.abs(v);
      isInertial = true;
      this.inertia(absV, Math.floor(absV / v), 0);
    },
    /**
     * 用户结束滑动，应该慢慢放慢，最终停止。从而需要 a(加速度)
     * @param start 开始速度
     * @param position 速度方向，值: 正负1
     * @param target 结束速度
     */
    inertia(start, position, target) {
      if (start <= target || !isInertial) {
        this.animate.stop();
        this.finger.prevMove = this.finger.currentMove;
        this.getSelectValue(this.finger.currentMove);
        return;
      }
      // 这段时间走的位移 S = vt + 1/2at^2;
      const move =
        position * start * (1000 / 60) +
        0.5 * a * (1000 / 60) * (1000 / 60) +
        this.finger.currentMove;
      // 根据求末速度公式： v末 = v初 + at
      const newStart = position * start + a * (1000 / 60);
      // 已经到达目标
      if (newStart <= target) {
        this.$refs.outdiv.style.transition =
          "transform 700ms cubic-bezier(0.19, 1, 0.22, 1)";
      } else {
        this.$refs.outdiv.style.transition = "";
      }
      this.finger.currentMove = move;
      let myPoisiton = Math.floor(move / lineHeight) * 40;
      if (move >= this.scrolldata.length * 40) {
        this.$refs.outdiv.style.transform = ` translate3d(0px, ${-(
          this.scrolldata.length * 40 -
          40
        )}px, 0px)`;
        return;
      }
      if (move < 0) {
        this.$refs.outdiv.style.transform = ` translate3d(0px, ${0}px, 0px)`;
        return;
      }
      this.$refs.outdiv.style.transform = ` translate3d(0px, ${-myPoisiton}px, 0px)`;
      this.animate.start(this.inertia.bind(this, newStart, position, target));
    }
  }
};
</script>
<style lang="less" scoped>
.contentoutside {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
  .content {
    position: absolute;
    z-index: 999;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 234px;
    background: rgba(255, 255, 255, 1);
    padding: 0 18px;
    overflow: hidden;
    .header {
      height: 16px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .cancel {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
      }
      .ok {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(54, 179, 116, 1);
      }
      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
    }
    .content-footer {
      width: 100%;
      height: 100%;
      padding: 0 32px;
      overflow: hidden;

      .content_t {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        .center-line {
          width: 100%;
          height: 40px;
          border-top: 1px solid #eeeeee;
          border-bottom: 1px solid #eeeeee;
          position: absolute;
          top: 67px;
          left: 0;
        }
        .content-inside {
          height: 40px;
          width: 100%;
          opacity: 1;
          margin-top: 67px;
          transform: translate3d(0px, 0px, 0px);
          transition-duration: 0ms;
          transition-property: none;
          .text {
            height: 40px;
            line-height: 40px;
            text-align: center;
          }
        }
        // .bottomopacity {
        //   position: absolute;
        //   left: 0;
        //   top: 0;
        //   right: 0;
        //   bottom: 0;
        //   background-image: linear-gradient(
        //       180deg,
        //       hsla(0, 0%, 100%, 0.95),
        //       hsla(0, 0%, 100%, 0.6)
        //     ),
        //     linear-gradient(
        //       0deg,
        //       hsla(0, 0%, 100%, 0.95),
        //       hsla(0, 0%, 100%, 0.6)
        //     );
        //   background-position: top, bottom;
        //   background-repeat: no-repeat;
        // }
      }
    }
  }
}
</style>
